import { render, staticRenderFns } from "./switches.vue?vue&type=template&id=3da8a646&scoped=true&"
import script from "./switches.vue?vue&type=script&lang=js&"
export * from "./switches.vue?vue&type=script&lang=js&"
import style0 from "./switches.vue?vue&type=style&index=0&id=3da8a646&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da8a646",
  null
  
)

export default component.exports